import { html } from '../core/html.js';
import { t } from '../core/i18n.js';
import { page, breadcrumbs } from '../components/chrome.js';
import { legalCta, legalSection, legalToc, legalTranslationNotice } from '../components/legal.js';
import { site } from '../data/site.js';

const sections = [
  { id: 'provider', iconName: 'building', titleKey: 'imprint.provider.title' },
  { id: 'contact-legal', iconName: 'mail', titleKey: 'imprint.contact.title' },
  { id: 'register', iconName: 'check', titleKey: 'imprint.register.title' },
  { id: 'tax', iconName: 'code', titleKey: 'imprint.tax.title' },
  { id: 'responsible', iconName: 'building', titleKey: 'imprint.responsible.title' },
  { id: 'liability', iconName: 'check', titleKey: 'imprint.disclaimer.title' },
  { id: 'copyright', iconName: 'check', titleKey: 'imprint.copyright.title' },
  { id: 'dispute', iconName: 'check', titleKey: 'imprint.dispute.title' },
];

export const ImprintPage = () => page(html`
  <section class="pagehead pagehead--legal" aria-labelledby="imprint-title">
    <div class="shell">
      ${breadcrumbs('nav.imprint')}
      <div class="pagehead__grid">
        <div>
          <p class="kicker">${t('imprint.page.eyebrow')}</p>
          <h1 class="pagehead__title" id="imprint-title">${t('imprint.title')}</h1>
          <p class="pagehead__lede">${t('imprint.page.description')}</p>
        </div>
        <aside class="pagehead__aside">
          <p class="kicker">${t('imprint.info.title')}</p>
          <p class="pagehead__note">
            <strong>${t('imprint.provider.company')}</strong><br />
            ${t('imprint.provider.owner')}: ${t('imprint.provider.owner.name')}<br />
            ${t('imprint.provider.address.street')}<br />
            ${t('imprint.provider.address.city')}, ${t('imprint.provider.address.country')}
          </p>
          <p class="pagehead__meta">${t('imprint.updated')} 27.09.2025</p>
        </aside>
      </div>
    </div>
  </section>

  <section class="section legal">
    <div class="shell legal__layout">
      ${legalToc({
        titleKey: 'imprint.summary.title',
        items: sections,
        meta: `${t('imprint.updated')} 27.09.2025`,
      })}
      <div class="legal__doc">
        ${legalTranslationNotice()}
        ${legalSection({
          id: 'provider',
          iconName: 'building',
          titleKey: 'imprint.provider.title',
          body: html`
            <p><strong>${t('imprint.provider.company')}</strong></p>
            <p>${t('imprint.provider.owner')}: ${t('imprint.provider.owner.name')}</p>
            <p>
              ${t('imprint.provider.address.street')}<br />
              ${t('imprint.provider.address.city')}<br />
              ${t('imprint.provider.address.country')}
            </p>
          `,
        })}

        ${legalSection({
          id: 'contact-legal',
          iconName: 'mail',
          titleKey: 'imprint.contact.title',
          body: html`
            <p>
              <strong>${t('imprint.contact.email')}</strong>:
              <a href="mailto:${site.email}">${site.email}</a>
            </p>
            <p>
              <strong>${t('imprint.contact.website')}</strong>:
              <a href="${site.url}">netbyte.bz</a>
            </p>
          `,
        })}

        ${legalSection({
          id: 'register',
          iconName: 'check',
          titleKey: 'imprint.register.title',
          body: html`
            <p><strong>${t('imprint.register.court')}</strong>: ${t('imprint.register.court.name')}</p>
            <p><strong>${t('imprint.register.number')}</strong>: ${t('imprint.register.number.value')}</p>
          `,
        })}

        ${legalSection({
          id: 'tax',
          iconName: 'code',
          titleKey: 'imprint.tax.title',
          body: html`
            <p><strong>${t('imprint.tax.number')}</strong>: ${t('imprint.tax.number.value')}</p>
            <p><strong>${t('imprint.tax.vat')}</strong>: ${t('imprint.tax.vat.value')}</p>
          `,
        })}

        ${legalSection({
          id: 'responsible',
          iconName: 'building',
          titleKey: 'imprint.responsible.title',
          body: html`
            <p><strong>${t('imprint.responsible.content')}</strong>:</p>
            <p>
              ${t('imprint.provider.owner.name')}<br />
              ${t('imprint.provider.address.street')}<br />
              ${t('imprint.provider.address.city')}
            </p>
          `,
        })}

        ${legalSection({
          id: 'liability',
          iconName: 'check',
          titleKey: 'imprint.disclaimer.title',
          body: html`
            <p><strong>${t('imprint.disclaimer.content.title')}</strong>:</p>
            <p>${t('imprint.disclaimer.content.text')}</p>
            <h3 class="legal__sub">${t('imprint.disclaimer.links.title')}</h3>
            <p>${t('imprint.disclaimer.links.text')}</p>
          `,
        })}

        ${legalSection({
          id: 'copyright',
          iconName: 'check',
          titleKey: 'imprint.copyright.title',
          body: html`<p>${t('imprint.copyright.text')}</p>`,
        })}

        ${legalSection({
          id: 'dispute',
          iconName: 'check',
          titleKey: 'imprint.dispute.title',
          body: html`
            <p>${t('imprint.dispute.text')}</p>
            <p>
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
            <p>${t('imprint.dispute.note')}</p>
          `,
        })}

        ${legalCta()}
      </div>
    </div>
  </section>
`, { modifier: 'main--legal' });
